// extracted by mini-css-extract-plugin
module.exports = {"root":"ScrollToTop_root__Tc8fx","hidden":"ScrollToTop_hidden__v0g25"};